require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/ecf67698/0/pomelo/oceopin/web/app/themes/oceopin/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 278
// module chunks = 0